module.exports = __webpack_public_path__ + "static/media/img_package-fresh.23efe070.png";